import useService from './useService';

/**
 * Hook to determine if the current service is a GitHub App.
 */
const useIsGithubApp = () => {
  const service = useService();
  return service === 'github-app';
};

export default useIsGithubApp;
